import { encodeTagsParam } from '../../../helpers/encodeTagsParam'
import type { ConfigFilters } from '../../../types'

// Map the applied ConfigFilters onto URL query params so the filtered view is
// shareable and survives reloads. The four column filters use their API param
// names and are set only when non-empty; tags is percent-encoded (see
// encodeTagsParam) so a comma inside a value never corrupts the delimiter.
// Starts from `current` so unrelated params are preserved. Inverse of
// readConfigFiltersFromParams.
export function buildConfigsSearchParams(
  current: URLSearchParams,
  filters: ConfigFilters
): URLSearchParams {
  const params = new URLSearchParams(current)

  const columnParams: [string, string][] = [
    ['tenantCodes', filters.tenant],
    ['inventorySystemProfileCodes', filters.isp],
    ['venueIds', filters.venue],
    ['configKeys', filters.configKey],
  ]

  columnParams.forEach(([name, value]) => {
    const trimmed = value.trim()
    if (trimmed) {
      params.set(name, trimmed)
      return
    }
    params.delete(name)
  })

  if (filters.tags.length) {
    params.set('tags', encodeTagsParam(filters.tags))
    return params
  }

  params.delete('tags')
  return params
}
